<script setup lang="ts">
    import { computed, ref } from 'vue'
    import PkUrl from '../PkUrl.vue'

    const props = defineProps<{
        part: unknown
    }>()

    const toolPart = computed(() => {
        const part = props.part as {
            output?: {
                pages: Array<{
                    title: string
                    url: string
                    image?: string
                    description?: string
                }>
            }
        }
        return part
    })

    const showMore = ref(false)
    const pages = computed(() => {
        if (showMore.value) {
            return toolPart.value.output?.pages || []
        }
        return (toolPart.value.output?.pages || []).slice(0, 2)
    })
    const hasMore = computed(
        () => (toolPart.value.output?.pages || []).length > 2,
    )
</script>

<template>
    <ul v-if="pages?.length" class="flex flex-col gap-xs w-full">
        <li
            v-for="(page, index) in pages"
            :key="index"
            class="border border-surface-3 rounded-lg overflow-hidden hover:border-surface-4 transition-colors shrink-0">
            <a
                :href="page.url"
                :title="$t('action.open')"
                target="_blank"
                rel="noopener noreferrer"
                class="flex gap-8 p-8 hover:bg-surface-1 transition-colors">
                <img
                    v-if="page.image"
                    :src="page.image"
                    :alt="page.title"
                    class="w-48 h-48 object-cover rounded shrink-0" />
                <div class="flex flex-col gap-4 min-w-0 flex-1">
                    <strong class="font-bold text-12 text-word-1 truncate">
                        {{ page.title }}
                    </strong>
                    <span
                        class="text-10 text-word-4 truncate flex items-center gap-4">
                        <VvIcon name="ri:link" class="shrink-0 text-12" />
                        <PkUrl :url="page.url" />
                    </span>
                    <p
                        v-if="page.description"
                        class="text-12 text-word-3 line-clamp-2">
                        {{ page.description }}
                    </p>
                </div>
            </a>
        </li>
        <li v-if="hasMore" class="text-center">
            <button
                class="text-12 text-word-3 cursor-pointer hover:underline flex items-center gap-4 mx-auto"
                @click="showMore = !showMore">
                <VvIcon
                    :name="
                        showMore ? 'ri:arrow-up-s-line' : 'ri:arrow-down-s-line'
                    "
                    class="text-16" />
                {{
                    showMore
                        ? $t('action.showLess')
                        : $t('action.showMore', {
                              count: (toolPart?.output?.pages?.length || 0) - 2,
                          })
                }}
            </button>
        </li>
    </ul>
</template>
